import React, { useState } from "react";
import { Share3 as ShareIcon } from "@piiqtechnologies/svg-icons";
import SpaceShareLinkDialog from "./SpaceShareLinkDialog";
import { PeekButton } from "@piiqtechnologies/ui-components";
import { useIntl } from "react-intl";
import messages from "./messages.i18n";
const DefaultShareLinkComponent = ({ onShareLink, disabled }) => {
    const intl = useIntl();
    return (React.createElement(PeekButton, { startIcon: React.createElement(ShareIcon, null), "aria-label": "Share Link", onClick: onShareLink, variant: "outlined", color: "info", size: "large", disabled: disabled, sx: { "> .MuiButton-startIcon": { width: 12 } } }, intl.formatMessage(messages.spaceShareLinkButton)));
};
export const SpaceShareLinkAction = ({ spaceId, communityId, ShareLinkComponent = DefaultShareLinkComponent, spaceType, disabled, }) => {
    const [openSpaceShareLinkDialog, setOpenSpaceShareLinkDialog] = useState(false);
    const toggleSpaceShareLinkDialog = () => {
        setOpenSpaceShareLinkDialog((prevDialogOpenState) => !prevDialogOpenState);
    };
    return (React.createElement(React.Fragment, null,
        React.createElement(ShareLinkComponent, { disabled: disabled, onShareLink: toggleSpaceShareLinkDialog }),
        React.createElement(SpaceShareLinkDialog, { spaceId: spaceId, communityId: communityId, onClose: toggleSpaceShareLinkDialog, open: openSpaceShareLinkDialog, spaceType: spaceType })));
};
export default SpaceShareLinkAction;
